export default {
  video: {
    desc: '您安全的加密貨幣硬體錢包',
    preOrderNow: '立即預訂',
    watchNow: '觀看了解',
  },

  introduce: {
    title: 'KeyPal，安全性與易用性兼備，優勢盡顯',
    desc_1: '點擊任意卡片以進一步了解',
    desc_2: '連接',
    desc_3: '安全',
    desc_4: '備份',
    desc_5: 'Passphrase',
    desc_6: '續航',
    desc_7: '電池容量',
    desc_8: '雙芯片',
    desc_9: '15宫格',
    desc_10: '多種連接方式，總有一款適合你',
    desc_11: 'NFC + KeyPal Card',
    desc_12: '使用',
    label_1: '支持藍牙以及掃描二維碼連接錢包、交易簽名',
    label_1_1: '根據不同場景選擇不同連接方式，讓硬體錢包的使用更安全、更便捷',
    label_2: 'KeyPal 2 支援 Passphrase',
    label_2_1: '使用相同的助記詞，搭配不同的 Passphrase 可進入不同錢包，為錢包再加上一道安全鎖',
    label_3: '支援 NFC，讓備份更簡單、更快速',
    label_3_1: 'KeyPal 2 可通过 NFC 将助记词快读备份到 KeyPal Card',
    label_4: '電池容量更大，從 300 mAh 提升至 500 mAh',
    label_4_1: '一次充電，可連續運作12小時，讓你遠離電量不足的焦慮',
    label_5: 'KeyPal 2 採用軍工級雙晶片設計',
    label_5_1: 'MCU + SE 的雙晶片架構，安全從核心開始',
    label_6: '15宮格設計，讓輸入與互動更簡單',
    label_6_1: '快速輸入內容、快速選擇功能，不再經歷漫長且複雜的流程',
  },

  support: {
    title: '支援數百萬種加密貨幣',
    desc_1: '查看支援清單',
  },

  other: {
    title: '其他 KeyPal 產品',
    desc_1: `KeyPal Plus 採用雙芯片架構，兼備易用性與安全性。極簡設計風格結合堅固的鋁合金外殼，打造耐用且高效的加密資產管理體驗。`,
    desc_2: `KeyPal Card 支援 NFC 通訊，一鍵輕鬆保存助記詞與私鑰，完美結合離線備份與簽名功能。銀行卡大小設計，便攜安全，隨時隨地保護您的加密資產。`,
    desc_3: `Secret Box 採用 304 不鏽鋼材質，具備卓越的耐高溫與耐腐蝕性能。字母塊與凹槽設計，使助記詞保存更加簡便且持久。A+B 面設計，支援 12×2、18 或 24 位助記詞存儲，為您的加密資產提供長期安全保障。`,
  },

  FAQ: {
    title: 'FAQ',
    desc_1: '點擊查看所有常見問題的解答。',
    question_1: '什麼是加密錢包?',
    question_2: '為什麼我需要一個硬體錢包？',
    question_3: '硬件钱包和 App 硬體錢包和 App 錢包有什麼不同？',
    question_4: '如果我丟了裝置，加密資產還安全嗎？',
    question_5: 'KeyPal 硬體錢包支援哪些類型的加密貨幣',
  },

  discover: {
    title: '選擇您最喜愛的 KeyPal 顏色',
    desc_1: '探索',
  },
};
